import { ChevronDown, ChevronUp } from "lucide-react";
import { cn } from "@/shared/lib/cn";

type SortableTableHeadProps = {
  label: string;
  columnKey: string;
  activeKey: string | null;
  direction: SortDirection;
  onSort: (key: string) => void;
  sortable?: boolean;
  className?: string;
};

const thClass =
  "px-4 py-3 text-left text-[11px] font-semibold uppercase tracking-wide text-muted";

export function SortableTableHead({
  label,
  columnKey,
  activeKey,
  direction,
  onSort,
  sortable = true,
  className,
}: SortableTableHeadProps) {
  if (!sortable) {
    return <th className={cn(thClass, className)}>{label}</th>;
  }

  const isActive = activeKey === columnKey;

  return (
    <th className={cn(thClass, className)}>
      <button
        type="button"
        onClick={() => onSort(columnKey)}
        className="inline-flex items-center gap-1 transition-colors hover:text-foreground"
      >
        {label}
        <span className="flex flex-col">
          <ChevronUp
            size={10}
            className={cn(
              "-mb-1",
              isActive && direction === "asc" ? "text-primary" : "text-muted/50",
            )}
          />
          <ChevronDown
            size={10}
            className={cn(isActive && direction === "desc" ? "text-primary" : "text-muted/50")}
          />
        </span>
      </button>
    </th>
  );
}
